import { Typography } from "@biggeo/bg-ui/lab";
import React from "react";

const calculateTimeDifference = (incomingDate: Date) => {
    const now = new Date();
    const date = new Date(incomingDate);
    const diff = Math.abs(now.getTime() - date.getTime());
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    return `${Math.abs(hours)}:${Math.abs(minutes).toString().padStart(2, "0")}:${Math.abs(seconds).toString().padStart(2, "0")}`;
};

export const Counter = ({ date }: { date: Date }) => {
    const [timeDiff, setTimeDiff] = React.useState(
        calculateTimeDifference(date)
    );

    React.useEffect(() => {
        const timer = setInterval(() => {
            setTimeDiff(calculateTimeDifference(date));
        }, 1000);

        return () => clearInterval(timer);
    }, [date]);

    if (new Date(date).getTime() <= new Date().getTime()) {
        return null;
    }

    return (
        <Typography
            variant="body4"
            fontWeight="semibold"
            color="disabled"
            invertColors
            colorSet="container"
        >
            {timeDiff}
        </Typography>
    );
};
